import React from 'react';

export class BrokenLink extends React.Component {
  render(){
      return (
        <div className="w3-card w3-animate-bottom full-project-card">
              <p>
                  404 error
              </p>
            <p>
                Sorry this link does not exist :(
                  Check out Leanna's projects from the projects button!         
            </p>
        </div>
    );
  }
}
